import { api } from '@/utils/api.js'

export function useBillingSessionCreate() {
  const createSession = async () => {
    return api.billing.setupIntent.create()
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        console.error(error)
        switch (error.response.status) {
          case 401:
            error.displayMessage = "Session has expired"
            break
          default:
            error.displayMessage = "Unable to create setup intent"
        }
        throw error
      })
  }

  return {
    createSession
  }
}